import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AccountServiceProvider } from '@services/user/account.service';
import { UserServiceProvider } from '@services/user/user.service';
import { User } from '@models/models';
import { Subscription } from 'rxjs';
import { UtilsServiceProvider } from '@services/utils/utils-service';
import { SubscriptionServiceProvider } from '@services/subscription/subscription.service';

@Component({
	selector: 'trial-modal',
	template: require('./trial-modal.html'),
	styles: [require('./trial-modal.scss')]
})
export class TrialModalWebComponent implements OnInit, OnDestroy {
	@Input('title') defaultTitle: string;
	private user: User;
	private userObservable: Subscription;
	private isAnnualDiscount: boolean;
	private isMonthlyDiscount: boolean;
	private title: string;
	private cancelText: string;

	constructor(
		private accountService: AccountServiceProvider,
		private userService: UserServiceProvider,
		private utilsService: UtilsServiceProvider,
		private subscriptionService: SubscriptionServiceProvider
	) {}

	ngOnInit() {
		this.getUser();
	}

	ngOnDestroy() {
		this.userObservable.unsubscribe();
	}

	private setTitle(): void {
		if (
			this.user.subscription.plan === 'UNPAID' &&
			this.user.subscription.freeDaysAccess > 0
		) {
			this.title = `You have ${
				this.user.subscription.freeDaysAccess
			} days left to update your credit card details.`;
		} else if (this.user.daysToUsePromotion >= 0 && this.user.promotionActive) {
			this.title = `Get 25% OFF for 12 months! Offer ends in ${this.user
				.daysToUsePromotion + 1} days.`;
		} else {
			this.title = this.defaultTitle;
		}
	}

	private setCancelText(): void {
		if (
			this.user.subscription.plan === 'UNPAID' &&
			this.user.subscription.freeDaysAccess > 0
		) {
			this.cancelText = 'Not right now, I need more time!';
		} else {
			this.cancelText =
				'No thanks. I want to continue using Studio Ninja for free!';
		}
	}

	private getUser() {
		this.userObservable = this.accountService.userDataObservable.subscribe(
			user => {
				if (user !== null && typeof user !== 'undefined') {
					this.user = JSON.parse(JSON.stringify(user));
					const {
						annualDiscount,
						monthlyDiscount
					} = this.userService.subscriptionData;
					this.isAnnualDiscount = annualDiscount;
					this.isMonthlyDiscount = monthlyDiscount;
					this.setTitle();
					this.setCancelText();
				}
			}
		);
	}

	subscribeStripeModal(plan: string, e: Event): void {
		this.subscriptionService.subscribeStripeModalWeb(plan, e);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/subscription/modals/trial-modal/trial-modal.ts